import { Injectable } from '@angular/core';

import { BaseImportService, HttpService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseImportService extends BaseImportService {
  protected constructor(
    protected baseRoute: string,
    protected filename: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, filename, httpService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
